import { render, staticRenderFns } from "./CategoriasCRUD.vue?vue&type=template&id=c27be8d6"
import script from "./CategoriasCRUD.vue?vue&type=script&lang=js"
export * from "./CategoriasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports